import { IconType } from '../../../types/icon.type';

type DropdownOption = { text: string; action: Function; icon: IconType };

export const getNewsFeedDropdownOptions = (
  source: string
): DropdownOption[] => [
  {
    text: 'Already Read This Article',
    action: () => {},
    icon: 'read',
  },
  {
    text: `Block "${source}"`,
    action: () => {},
    icon: 'remove',
  },
  {
    text: `Not Interested`,
    action: () => {},
    icon: 'sad',
  },
  {
    text: `Share Article To Channel`,
    action: () => {},
    icon: 'share',
  },
];

export const getSocialFeedDropdownOptions = (): DropdownOption[] => [
  {
    text: `Not Interested`,
    action: () => {},
    icon: 'sad',
  },
];

export const getHoldrFeedDropdownOptions = (
  username: string
): DropdownOption[] => [
  {
    text: `Untrack @${username}`,
    action: () => {},
    icon: 'untrack',
  },
  {
    text: `Mute @${username}`,
    action: () => {},
    icon: 'mute',
  },
];

export const getSharedFeedDropdownOptions = (): DropdownOption[] => [
  {
    text: `Hide Post From Feed`,
    action: () => {},
    icon: 'hide',
  },
];

export const getEventsDropdownOptions = (): DropdownOption[] => [
  {
    text: `Not Interested`,
    action: () => {},
    icon: 'remove',
  },
  {
    text: `Already Going`,
    action: () => {},
    icon: 'ticket',
  },
  {
    text: `Notify Me In Advance`,
    action: () => {},
    icon: 'notifications',
  },
  {
    text: `Hide This Event`,
    action: () => {},
    icon: 'hide',
  },
  {
    text: `Report`,
    action: () => {},
    icon: 'flag',
  },
];

export const getJoinedChannelDropdownOptions = (): DropdownOption[] => [
  {
    text: `Leave channel`,
    action: () => {},
    icon: 'remove',
  },
  {
    text: `Add to favourites`,
    action: () => {},
    icon: 'like',
  },
  {
    text: `Mute this channel`,
    action: () => {},
    icon: 'mute',
  },
  {
    text: `Report`,
    action: () => {},
    icon: 'flag',
  },
];

export const getUnjoinedChannelDropdownOptions = (): DropdownOption[] => [
  {
    text: `Join channel`,
    action: () => {},
    icon: 'add',
  },
  {
    text: `Not Interested`,
    action: () => {},
    icon: 'sad',
  },
  {
    text: `Report`,
    action: () => {},
    icon: 'flag',
  },
];
